module.exports = do ->
   Backbone = require("backbone")

   Navigator = (route, trigger=true) ->
      Backbone.history.navigate(route, trigger)
